import React, { useContext, useEffect, useState } from "react";

import { Grid, Grow, IconButton, Tooltip } from "@material-ui/core";

import TableDefault from "../../../../components/grid/TableDefault";
import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { Header, Documentos } from "../styles/Emissao";
import Select from "../../../../components/basics/SelectErp";
import Icon from "@material-ui/core/Icon";
import {
  DeleteOutlineOutlined,
  EditOutlined,
  InfoRounded,
} from "@material-ui/icons";
import useEmissaoController from "../controllers/EmissaoController";
import { EmissaoContext } from "../contexts/EmissaoContext";
import moment from "moment";
import "moment/locale/pt-br";

const TabEmissaoDocumentos = ({ ...props }) => {
  const {
    setDocTable,
    docTable,
    visualizationOnly,
    listTaxNoteModel,
    taxNoteDefaultModels,
    taxNoteRuralProducerModels,
    isRuralProducerSender,
  } = useContext(EmissaoContext);

  const {
    handleAddAccesKey,
    docAccessKey,
    setDocAccessKey,
    refDocSerie,
    setRefDocSerie,
    refDocNumber,
    setRefDocNumber,
    refDocIssueDate,
    setRefDocIssueDate,
    docFreightModality,
    setDocFreightModality,
    docError,
    handleEditAccessKey,
    handleConfirmActionItem,
  } = useEmissaoController();

  const [listModels, setListModels] = useState(listTaxNoteModel);

  useEffect(() => {
    const allowedModels = isRuralProducerSender
      ? [...taxNoteRuralProducerModels, ...taxNoteDefaultModels]
      : taxNoteDefaultModels;

    const newListModels = listTaxNoteModel.filter((model) =>
      allowedModels.includes(model.value)
    );
    setListModels(newListModels);

    if (
      taxNoteRuralProducerModels.includes(docFreightModality?.value) &&
      !isRuralProducerSender
    )
      setDocFreightModality(newListModels[0]);
  }, [
    taxNoteDefaultModels,
    docFreightModality?.value,
    listTaxNoteModel,
    taxNoteRuralProducerModels,
    isRuralProducerSender,
    setDocFreightModality,
  ]);

  useEffect(() => {
    if (taxNoteDefaultModels.includes(docFreightModality?.value)) {
      setRefDocSerie(null);
      setRefDocNumber(null);
      setRefDocIssueDate(null);
    } else if (taxNoteRuralProducerModels.includes(docFreightModality?.value)) {
      setDocAccessKey(null);
    }
  }, [
    taxNoteDefaultModels,
    docFreightModality,
    taxNoteRuralProducerModels,
    setDocAccessKey,
    setRefDocIssueDate,
    setRefDocNumber,
    setRefDocSerie,
  ]);

  const columnsTableDocs = [
    {
      label: "Ações",
      format: (value) => {
        return (
          <>
            <Tooltip title="Editar">
              <IconButton
                onClick={() => {
                  handleEditAccessKey(value.index);
                }}
              >
                <EditOutlined />
              </IconButton>
            </Tooltip>
            <Tooltip title="Deletar">
              <IconButton
                onClick={() => {
                  handleConfirmActionItem(value.index, docTable, setDocTable);
                }}
              >
                <DeleteOutlineOutlined />
              </IconButton>
            </Tooltip>
          </>
        );
      },
      align: "center",
    },
    { label: "Modelo", id: "docModeloLabel" },
    { label: "Chave Acesso", id: "docChaveAcesso" },
    { label: "Série", id: "refDocSerie" },
    { label: "Número", id: "refDocNumber" },
    {
      label: "Data Emissão",
      id: "refDocIssueDate",
      format: (item) =>
        item.refDocIssueDate
          ? moment(item.refDocIssueDate).format("DD/MM/YYYY")
          : "",
    },
  ];

  return (
    <Documentos>
      <Grow in={true}>
        <Grid container spacing={2}>
          <Grid item lg={12} sm={12}>
            <TableDefault
              initialSize={17}
              columns={columnsTableDocs}
              values={docTable}
              tableTitle={
                <Header>
                  <Grid container spacing={2}>
                    <Grid item sm={3}>
                      <Select
                        optionsList={listModels}
                        descriptionField="label"
                        label="Modelo"
                        value={docFreightModality}
                        setValue={setDocFreightModality}
                        error={docError.docFreightModality ? true : false}
                        helperText={docError.docFreightModality || ""}
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    {taxNoteDefaultModels.includes(
                      docFreightModality?.value
                    ) && (
                      <Grid item sm>
                        <TextFieldErp
                          value={docAccessKey}
                          setValue={setDocAccessKey}
                          onChange={({ target: { value } }) => {
                            setDocAccessKey(
                              (value || "").replace(/[^0-9]/g, "")
                            );
                          }}
                          error={docError.docAccessKey ? true : false}
                          helperText={docError.docAccessKey || ""}
                          label="Chave de Acesso"
                          size="small"
                          maxLength={44}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                    )}
                    {taxNoteRuralProducerModels.includes(
                      docFreightModality?.value
                    ) && (
                      <>
                        <Grid item container spacing={2} xs={3}>
                          <Grid item xs={9}>
                            <TextFieldErp
                              value={refDocSerie}
                              setValue={setRefDocSerie}
                              onChange={({ target: { value } }) => {
                                setRefDocSerie(
                                  (value || "0").replace(/[^0-9]/g, "")
                                );
                              }}
                              error={docError.refDocSerie ? true : false}
                              helperText={docError.refDocSerie || ""}
                              label="Série"
                              size="small"
                              maxLength={3}
                              disabled={visualizationOnly}
                            />
                          </Grid>
                          <Grid item container xs alignItems="center">
                            <Tooltip title="Caso a série não seja informada, o valor considerado será 0">
                              <InfoRounded color="primary" />
                            </Tooltip>
                          </Grid>
                        </Grid>
                        <Grid item sm xs={3}>
                          <TextFieldErp
                            value={refDocNumber}
                            setValue={setRefDocNumber}
                            onChange={({ target: { value } }) => {
                              setRefDocNumber(
                                (value || "").replace(/[^0-9]/g, "")
                              );
                            }}
                            error={docError.refDocNumber ? true : false}
                            helperText={docError.refDocNumber || ""}
                            label="Número"
                            size="small"
                            maxLength={9}
                            disabled={visualizationOnly}
                          />
                        </Grid>
                        <Grid item xs={3}>
                          <TextFieldErp
                            value={refDocIssueDate}
                            setValue={setRefDocIssueDate}
                            error={docError.refDocIssueDate ? true : false}
                            helperText={docError.refDocIssueDate || ""}
                            label="Data Emissão"
                            size="small"
                            type="date"
                            disabled={visualizationOnly}
                          />
                        </Grid>
                      </>
                    )}
                    <Grid item>
                      <Btn
                        onClick={handleAddAccesKey}
                        startIcon={<Icon>add</Icon>}
                        label="Adicionar"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                  </Grid>
                </Header>
              }
            />
          </Grid>
        </Grid>
      </Grow>
    </Documentos>
  );
};

export default TabEmissaoDocumentos;
